export const VERSION_UPDATE_EVENT = "app:version-update-detected";

export const triggerVersionUpdate = (newVersion: string) => {
  const event = new CustomEvent(VERSION_UPDATE_EVENT, { detail: newVersion });
  window.dispatchEvent(event);
};
